import { Box } from '@mui/material';
import { SparkFormImageUploader } from 'sharedComponents/SparkForm';
import SparkSectionHeader from '../SparkSectionHeader';
type Props = {
  onChangeThumbnail: (imageURL: string) => void;
};
function Thumbnail({ onChangeThumbnail }: Props) {
  return (
    <Box>
      <SparkSectionHeader
        headerText='Thumbnail'
        subHeaderText="Let's make your Spark look nice"
      />
      <SparkFormImageUploader
        name='imageURL'
        containerName='app-assets'
        onUpload={onChangeThumbnail}
      />
    </Box>
  );
}

export default Thumbnail;
